/**
 * Whether a listener is signed in: the JWT fetchWrapper sends is held in
 * sessionStorage. sessionStorage fires no events, so providers that depend
 * on this re-read it on every route change — every sign-in and sign-out
 * ends in one (OAuthPage → /home, fetchWrapper → /login).
 */
export const readSession = () => {
  try {
    return Boolean(sessionStorage.getItem('jwt'));
  } catch {
    return false;
  }
};
